import {DPWidget} from '../widgets.types';

function getWidget(widgetStr: string): DPWidget {
  if (!widgetStr) return null;

  return JSON.parse(widgetStr) as DPWidget;
}

export default getWidget;
